import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { AbstractBookIssueEditComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import * as route from '~/helper/constant/route'
import { withTranslation } from 'react-i18next'
import { Button, Input, TextArea, Checkbox } from '~/components/form'
import { Loading } from '~/components/loader'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import * as Status from '~/helper/constant/book_issue_status'

class BookIssueEditComponent extends AbstractBookIssueEditComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this._setDate = this._setDate.bind(this)
        this._selectList = this._selectList.bind(this)
        // this.selectBookList = this.selectBookList.bind(this)
    }

    // selectBookList(data){
    //     const book =  this.state.bookObject.find(shelf => shelf.id === data.value)
    //     this.setState({
    //         defaultBook:data,
    //         selectedBook:data.value,
    //         bookShelves: book.book_shelf.map(shelve=> {

    //             return {
    //                 label: shelve.shelves.name,
    //                 value: shelve.shelves.id
    //         }

    //         })
    //     })
    // }

    _setDate(selectDate, data) {
        this._handleChange(selectDate, data)
    }

    _selectList(selecttype, data) {
        this.setState({
            [`default${selecttype}`]: data,
            [`selected${selecttype}`]: data.value,
        })
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text={this.state.loading_text} />
                <Sidebar id="library" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.library.menu}>{t('library:library')} > </a>
                            </li>
                            <li>
                                <a href={route.admin.library.bookissue.view}>{t('library:bookissue')} > </a>
                            </li>
                            <li>{t('common:EditBtn')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('library:editbookissue')} :</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <form>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('library:books')}*</label>
                                    <Input
                                        readOnly
                                        placeholder={t('library:book')}
                                        type="text"
                                        value={this.state.book}
                                    />
                                    {/* <Select 
                                    className="mb-3"
                                    value={this.state.defaultBook}
                                    name="selectedBook"
                                    options={this.state.books}
                                    placeholder={t('common:select')}
                                    searchable={true}
                                    onChange= {this.selectBookList}
                                    /> */}
                                    {/* {this.state.errors.selectedBook && <label className="error text-danger">{this.state.errors.selectedBook}</label>} */}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('library:bookshelves')} *</label>
                                    <Input
                                        readOnly
                                        placeholder={t('library:book')}
                                        type="text"
                                        value={this.state.bookShelf}
                                    />
                                    {/* <Select 
                                    className="mb-3"
                                    value={this.state.defaultBookShelves}
                                    name="selectedBookShelves"
                                    options={this.state.bookShelves}
                                    placeholder={t('common:select')}
                                    searchable={true}
                                    onChange= {(data)=>this._selectList('BookShelves', data)}
                                    />
                                    {this.state.errors.selectedBookShelves && <label className="error text-danger">{this.state.errors.selectedBookShelves}</label>} */}
                                </div>

                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('sidebar:users')} *</label>

                                    <Select
                                        className="mb-3"
                                        name="users"
                                        isDisabled={this.state.issueStatus == Status.RETURNED}
                                        value={this.state.defaultUser}
                                        options={this.state.users}
                                        placeholder={t('common:select')}
                                        searchable={true}
                                        onChange={(data) => this._selectList('User', data)}
                                    />
                                    {this.state.errors.selectedUser && (
                                        <label className="error text-danger">{this.state.errors.selectedUser}</label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title text-left">{t('income:issuedate')} *</label>
                                    <DatePicker
                                        name="issueDate"
                                        readOnly
                                        placeholderText={t('income:issuedate')}
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        selected={this.state.issueDate ? new Date(this.state.issueDate) : null}
                                    />
                                    {this.state.errors.issueDate && (
                                        <label className="error text-danger">{this.state.errors.issueDate}</label>
                                    )}
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title text-left">{t('income:duedate')} *</label>
                                    <DatePicker
                                        placeholderText={t('income:duedate')}
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        readOnly
                                        selected={this.state.dueDate ? new Date(this.state.dueDate) : null}
                                    />
                                    {this.state.errors.dueDate && (
                                        <label className="error text-danger">{this.state.errors.dueDate}</label>
                                    )}
                                </div>
                            </div>

                            <div className="row clearfix">
                                <div className="col-sm-3 float-left form-group">
                                    <Button
                                        onClick={this.onSave}
                                        type="submit"
                                        text={t('common:savebtn')}
                                        main={true}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const BookIssueEdit = withTranslation()(connect(mapStateToProps)(BookIssueEditComponent))

export { BookIssueEdit }
